import { atom } from "jotai";
import { atomFamily } from "jotai-family";

import type { EventMemberDetail } from "@/lib/schemas";

export const eventMembersFamily = atomFamily((_eventId: string) =>
  atom<EventMemberDetail[]>([]),
);
